import { 
  DiPython, DiJavascript1, DiReact, DiNodejs, DiGit, DiMongodb, DiMysql, DiDocker,
  DiJava
} from 'react-icons/di';
import { 
  SiTypescript, SiCplusplus, SiGo, SiR, SiTensorflow, SiPytorch, SiPandas,
  SiNumpy, SiScikitlearn, SiDjango, SiFlask, SiNextdotjs, SiVuedotjs, SiAngular,
  SiExpress, SiAmazonaws, SiMicrosoftazure, SiGooglecloud, SiKubernetes, SiRedis,
  SiVisualstudiocode, SiPostman, SiJupyter, SiPowerbi, SiTableau, SiMicrosoftexcel,
  SiPostgresql
} from 'react-icons/si';
import { FaCode, FaTools, FaChartBar, FaCogs, FaSearch, FaLayerGroup, FaBrain, FaEye } from 'react-icons/fa';

// Updated skills data with React Icons
export const skills = [
  // Programming Languages
  {
    name: "Python",
    icon: DiPython,
    color: "#3776ab",
    category: "Programming Languages"
  },
  {
    name: "JavaScript",
    icon: DiJavascript1,
    color: "#F7DF1E",
    category: "Programming Languages"
  },
  {
    name: "TypeScript",
    icon: SiTypescript,
    color: "#3178c6",
    category: "Programming Languages"
  },
  {
    name: "Java",
    icon: DiJava,
    color: "#007396",
    category: "Programming Languages"
  },
  {
    name: "C++",
    icon: SiCplusplus,
    color: "#00599C",
    category: "Programming Languages"
  },
  {
    name: "Go",
    icon: SiGo,
    color: "#00ADD8",
    category: "Programming Languages"
  },
  {
    name: "R",
    icon: SiR,
    color: "#276DC3",
    category: "Programming Languages"
  },

  // Libraries & Frameworks
  {
    name: "React",
    icon: DiReact,
    color: "#61dafb",
    category: "Libraries & Frameworks"
  },
  {
    name: "Node.js",
    icon: DiNodejs,
    color: "#339933",
    category: "Libraries & Frameworks"
  },
  {
    name: "Next.js",
    icon: SiNextdotjs,
    color: "#FFFFFF", // Changed from #000000 for better visibility in dark mode
    category: "Libraries & Frameworks"
  },
  {
    name: "Vue.js",
    icon: SiVuedotjs,
    color: "#4FC08D",
    category: "Libraries & Frameworks"
  },
  {
    name: "Angular",
    icon: SiAngular,
    color: "#DD0031",
    category: "Libraries & Frameworks"
  },
  {
    name: "Express.js",
    icon: SiExpress,
    color: "#FFFFFF", // Changed from #000000 for better visibility in dark mode
    category: "Libraries & Frameworks"
  },
  {
    name: "Django",
    icon: SiDjango,
    color: "#44B78B", // Changed from #092E20 to a brighter green for better visibility
    category: "Libraries & Frameworks"
  },
  {
    name: "Flask",
    icon: SiFlask,
    color: "#FFFFFF", // Changed from #000000 for better visibility in dark mode
    category: "Libraries & Frameworks"
  },
  {
    name: "TensorFlow",
    icon: SiTensorflow,
    color: "#FF6F00",
    category: "Libraries & Frameworks"
  },
  {
    name: "PyTorch",
    icon: SiPytorch,
    color: "#EE4C2C",
    category: "Libraries & Frameworks"
  },
  {
    name: "Pandas",
    icon: SiPandas,
    color: "#150458",
    category: "Libraries & Frameworks"
  },
  {
    name: "NumPy",
    icon: SiNumpy,
    color: "#013243",
    category: "Libraries & Frameworks"
  },
  {
    name: "Scikit-learn",
    icon: SiScikitlearn,
    color: "#F7931E",
    category: "Libraries & Frameworks"
  },

  // Tools & Platforms
  {
    name: "Git",
    icon: DiGit,
    color: "#F05032",
    category: "Tools & Platforms"
  },
  {
    name: "Docker",
    icon: DiDocker,
    color: "#2496ED",
    category: "Tools & Platforms"
  },
  {
    name: "Kubernetes",
    icon: SiKubernetes,
    color: "#326CE5",
    category: "Tools & Platforms"
  },
  {
    name: "AWS",
    icon: SiAmazonaws,
    color: "#232F3E",
    category: "Tools & Platforms"
  },
  {
    name: "Azure",
    icon: SiMicrosoftazure,
    color: "#0078D4",
    category: "Tools & Platforms"
  },
  {
    name: "Google Cloud",
    icon: SiGooglecloud,
    color: "#4285F4",
    category: "Tools & Platforms"
  },
  {
    name: "MongoDB",
    icon: DiMongodb,
    color: "#47A248",
    category: "Tools & Platforms"
  },
  {
    name: "PostgreSQL",
    icon: SiPostgresql,
    color: "#336791",
    category: "Tools & Platforms"
  },
  {
    name: "MySQL",
    icon: DiMysql,
    color: "#4479A1",
    category: "Tools & Platforms"
  },
  {
    name: "Redis",
    icon: SiRedis,
    color: "#DC382D",
    category: "Tools & Platforms"
  },
  {
    name: "VS Code",
    icon: SiVisualstudiocode,
    color: "#007ACC",
    category: "Tools & Platforms"
  },
  {
    name: "Jupyter",
    icon: SiJupyter,
    color: "#F37626",
    category: "Tools & Platforms"
  },
  {
    name: "Postman",
    icon: SiPostman,
    color: "#FF6C37",
    category: "Tools & Platforms"
  },
  {
    name: "Power BI",
    icon: SiPowerbi,
    color: "#F2C811",
    category: "Tools & Platforms"
  },
  {
    name: "Tableau",
    icon: SiTableau,
    color: "#E97627",
    category: "Tools & Platforms"
  },
  {
    name: "Microsoft Excel",
    icon: SiMicrosoftexcel,
    color: "#217346",
    category: "Tools & Platforms"
  }
];

// Updated Component to render skills with React Icons - with tooltip on hover
export const SkillIcon = ({ skill }) => {
  const IconComponent = skill.icon;
  return (
    <div className="relative group">
      {/* Tooltip */}
      <div className="absolute -top-10 left-1/2 -translate-x-1/2 scale-0 group-hover:scale-100 transition-all duration-200 bg-white text-dark text-xs font-semibold px-2 py-1 rounded shadow-lg z-20 whitespace-nowrap">
        {skill.name}
      </div>

      {/* Icon with glow effect */}
      <div className="p-4 rounded-xl bg-dark-light/60 border border-white/10 flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-[0_0_12px_4px_rgba(255,255,255,0.1)]">
        <IconComponent 
          size={32} 
          color={skill.color} 
          style={{ 
            filter: 'brightness(1.4) drop-shadow(0 0 4px rgba(255,255,255,0.25))', 
            mixBlendMode: 'lighten' 
          }}
        />
      </div>
    </div>
  );
};
